export default "__VITE_ASSET__7e_vKovX__"